import React from 'react';
import { Icon, IconName } from '../ui/Icon';
import { Badge } from '../ui/Badge';

interface FeatureCardProps {
  icon: IconName;
  title: string;
  body: string;
  badge?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, body, badge }) => (
  <div className="card card-hover" style={{ padding: 24 }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 14,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: 10,
          background: 'var(--brand-navy)',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name={icon} size={19} color="#fff" />
      </div>
      {badge && <Badge tone="cyan">{badge}</Badge>}
    </div>
    <h3 style={{ fontSize: 17, fontWeight: 600 }}>{title}</h3>
    <p className="muted" style={{ fontSize: 14, lineHeight: 1.55, marginTop: 8 }}>{body}</p>
  </div>
);

const FeaturesSection: React.FC = () => (
  <section className="page" style={{ paddingTop: 80 }}>
    <div style={{ textAlign: 'center', maxWidth: 680, margin: '0 auto 48px' }}>
      <span className="kicker">Platform</span>
      <h2 style={{ fontSize: 44, fontWeight: 600, letterSpacing: '-0.025em', marginTop: 16 }}>
        Everything you need to ship,{' '}
        <span style={{ fontFamily: 'var(--font-disp)', fontStyle: 'italic', fontWeight: 400 }}>
          nothing you don't.
        </span>
      </h2>
    </div>
    <div className="grid-3">
      <FeatureCard
        icon="zap"
        title="Instant rate comparison"
        body="Get live quotes from every major carrier in under 400ms. No logins, no phone calls."
      />
      <FeatureCard
        icon="wallet"
        title="Pre-paid wallet"
        body="Top up once, pay from balance. Multi-currency with auto-conversion at market rates."
      />
      <FeatureCard
        icon="route"
        title="Unified tracking"
        body="One page for every shipment across every carrier. Real-time events, ETA, proof of delivery."
      />
      <FeatureCard
        icon="bot"
        title="AI shipment"
        body="Paste an address or invoice. Our assistant fills the form, picks the carrier, books it."
        badge="NEW"
      />
      <FeatureCard
        icon="code"
        title="Developer API"
        body="REST + webhooks. Create labels programmatically, sync to your e-commerce stack."
      />
      <FeatureCard
        icon="shield"
        title="Insured by default"
        body="Every shipment covered up to $100. Upgradeable to full declared value."
      />
    </div>
  </section>
);

export default FeaturesSection;
